import * as React from 'react';
import type { SVGProps } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 65 64" {...props}>
        <path
            fill="#1f2937"
            stroke="#1f2937"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={4.267}
            d="M32.666 58.667c14.728 0 26.667-11.94 26.667-26.667 0-14.728-11.939-26.667-26.666-26.667C17.938 5.333 6 17.273 6 32c0 14.727 11.939 26.667 26.666 26.667Z"
        />
        <path
            fill="#fff"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={5.333}
            d="m27.333 21.333 16 10.667-16 10.667V21.333Z"
        />
    </svg>
);

export { SvgComponent as PlayCircleFilled };
